const COMPONENT_NAME = "MarkdownRenderer";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error: Missing required parameter markdown`;
export {
  COMPONENT_NAME,
  INVALID_PROPS_ERROR
};
